export const iconFontAwesomeUsersPeoplePersonRunning = (
	<i className="fa-solid fa-person-running"></i>
);
